import React from 'react';

export const CuboidIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      className="g-annotation-icon"
      d="M20.29 6.63012L12.5 2.13012C12.19 1.95012 11.81 1.95012 11.5 2.13012L3.70996 6.63012C3.39996 6.81012 3.20996 7.14012 3.20996 7.50012V16.5001C3.20996 16.8601 3.39996 17.1901 3.70996 17.3701L11.5 21.8701C11.65 21.9601 11.83 22.0001 12 22.0001C12.17 22.0001 12.35 21.9601 12.5 21.8701L20.29 17.3701C20.6 17.1901 20.79 16.8601 20.79 16.5001V7.50012C20.79 7.14012 20.6 6.81012 20.29 6.63012ZM12 4.15012L17.81 7.50012L12 10.9101L6.18996 7.51012L12 4.15012ZM5.20996 9.25012L11 12.6501V19.2701L5.20996 15.9201V9.25012ZM13 19.2701V12.6501L18.79 9.25012V15.9301L13 19.2701Z"
    />
  </svg>
);

export const SegmentationIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      className="g-annotation-icon"
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM19.93 11H15.86C15.5 9.6 14.4 8.5 13 8.14V4.07C16.62 4.52 19.48 7.38 19.93 11ZM12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14ZM4 12C4 7.92 7.05 4.56 11 4.07V8.14C9.28 8.59 8 10.14 8 12C8 13.86 9.28 15.41 11 15.86V19.93C7.05 19.44 4 16.08 4 12ZM13 19.93V15.86C14.4 15.5 15.5 14.4 15.86 13H19.93C19.48 16.62 16.62 19.48 13 19.93Z"
    />
  </svg>
);

export const BoundingBoxIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      className="g-annotation-icon"
      d="M20 3H4C3.45 3 3 3.45 3 4V20C3 20.55 3.45 21 4 21H20C20.55 21 21 20.55 21 20V4C21 3.45 20.55 3 20 3ZM5 5H19V19H13V12C13 11.45 12.55 11 12 11H5V5ZM11 13V19H5V13H11Z"
    />
  </svg>
);

export const ClassificationIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      className="g-annotation-icon"
      d="M10 13H4C3.45 13 3 13.45 3 14V20C3 20.55 3.45 21 4 21H10C10.55 21 11 20.55 11 20V14C11 13.45 10.55 13 10 13ZM9 19H5V15H9V19ZM20.71 14.71L18.41 17L20.7 19.29C21.09 19.68 21.09 20.31 20.7 20.7C20.51 20.9 20.26 21 20 21C19.74 21 19.49 20.9 19.29 20.71L17 18.41L14.71 20.7C14.51 20.9 14.26 21 14 21C13.74 21 13.49 20.9 13.29 20.71C12.9 20.32 12.9 19.69 13.29 19.3L15.59 17L13.3 14.71C12.91 14.32 12.91 13.69 13.3 13.3C13.69 12.91 14.32 12.91 14.71 13.3L17 15.59L19.29 13.3C19.68 12.91 20.31 12.91 20.7 13.3C21.1 13.68 21.1 14.32 20.71 14.71ZM21.33 9.5L17.87 3.5C17.51 2.88 16.49 2.88 16.14 3.5L12.68 9.5C12.5 9.81 12.5 10.19 12.68 10.5C12.86 10.81 13.19 11 13.55 11H20.48C20.84 11 21.17 10.81 21.35 10.5C21.51 10.19 21.51 9.81 21.33 9.5ZM15.27 9L17 6L18.73 9H15.27ZM7 3C4.79 3 3 4.79 3 7C3 9.21 4.79 11 7 11C9.21 11 11 9.21 11 7C11 4.79 9.21 3 7 3ZM7 9C5.9 9 5 8.1 5 7C5 5.9 5.9 5 7 5C8.1 5 9 5.9 9 7C9 8.1 8.1 9 7 9Z"
    />
  </svg>
);

export const PolygonIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      className="g-annotation-icon"
      d="M22.0501 9.06994L12.5901 2.18994C12.2401 1.93994 11.7601 1.93994 11.4101 2.18994L1.95012 9.06994C1.60012 9.31994 1.45012 9.77994 1.59012 10.1899L5.20012 21.3099C5.33012 21.7199 5.72012 21.9999 6.15012 21.9999H17.8501C18.2801 21.9999 18.6701 21.7199 18.8001 21.3099L22.4101 10.1899C22.5501 9.76994 22.4001 9.31994 22.0501 9.06994ZM11.2701 19.9999H6.87012L5.51012 15.8199L9.07012 13.2399L12.6301 15.8199L11.2701 19.9999ZM17.1201 19.9999H13.3701L14.7501 15.7499C14.8801 15.3399 14.7401 14.8899 14.3901 14.6299L9.66012 11.1899C9.31012 10.9399 8.83012 10.9399 8.48012 11.1899L4.86012 13.8199L3.70012 10.2599L12.0001 4.23994L20.2901 10.2599L17.1201 19.9999Z"
    />
  </svg>
);

export const PointIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      className="g-annotation-icon"
      d="M13.5 3.5C13.5 4.3 12.8 5 12 5C11.2 5 10.5 4.3 10.5 3.5C10.5 2.7 11.2 2 12 2C12.8 2 13.5 2.7 13.5 3.5ZM12 19C11.2 19 10.5 19.7 10.5 20.5C10.5 21.3 11.2 22 12 22C12.8 22 13.5 21.3 13.5 20.5C13.5 19.7 12.8 19 12 19ZM12 10.5C11.2 10.5 10.5 11.2 10.5 12C10.5 12.8 11.2 13.5 12 13.5C12.8 13.5 13.5 12.8 13.5 12C13.5 11.2 12.8 10.5 12 10.5ZM7.8 14.7C7 14.7 6.3 15.4 6.3 16.2C6.3 17 7 17.7 7.8 17.7C8.6 17.7 9.3 17 9.3 16.2C9.3 15.4 8.6 14.7 7.8 14.7ZM7.8 6.2C7 6.2 6.3 6.9 6.3 7.7C6.3 8.5 7 9.2 7.8 9.2C8.6 9.2 9.3 8.5 9.3 7.7C9.3 6.9 8.6 6.2 7.8 6.2ZM16.3 6.2C15.5 6.2 14.8 6.9 14.8 7.7C14.8 8.5 15.5 9.2 16.3 9.2C17.1 9.2 17.8 8.5 17.8 7.7C17.8 6.9 17.1 6.2 16.3 6.2ZM16.3 14.7C15.5 14.7 14.8 15.4 14.8 16.2C14.8 17 15.5 17.7 16.3 17.7C17.1 17.7 17.8 17 17.8 16.2C17.8 15.4 17.1 14.7 16.3 14.7ZM3.5 10.5C2.7 10.5 2 11.2 2 12C2 12.8 2.7 13.5 3.5 13.5C4.3 13.5 5 12.8 5 12C5 11.2 4.3 10.5 3.5 10.5ZM20.5 10.5C19.7 10.5 19 11.2 19 12C19 12.8 19.7 13.5 20.5 13.5C21.3 13.5 22 12.8 22 12C22 11.2 21.3 10.5 20.5 10.5Z"
    />
  </svg>
);

export const LinesSplinesIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      className="g-annotation-icon"
      d="M21 6.7V20C21 20.6 20.6 21 20 21C19.4 21 19 20.6 19 20V6.7C19 5.7 18.3 5 17.3 5C16.3 5 15.6 5.7 15.6 6.7V17.4C15.6 19.4 14 21.1 11.9 21.1C9.8 21.1 8.2 19.5 8.2 17.4V4C8.2 3.4 8.6 3 9.2 3C9.8 3 10.2 3.4 10.2 4V17.3C10.2 18.2 10.9 19 11.9 19C12.9 19 13.6 18.3 13.6 17.3V6.7C13.6 4.7 15.2 3 17.3 3C19.4 3 21 4.6 21 6.7ZM4 3C3.4 3 3 3.4 3 4V20C3 20.6 3.4 21 4 21C4.6 21 5 20.6 5 20V4C5 3.4 4.6 3 4 3Z"
    />
  </svg>
);

export const TranscriptionIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      className="g-annotation-icon"
      d="M4 17.9999H7.59C7.86 17.9999 8.11 17.8899 8.3 17.7099L17.97 8.03994C18.76 7.24994 19.18 6.08994 18.94 4.83994C18.67 3.45994 17.54 2.32994 16.16 2.06994C14.92 1.83994 13.76 2.24994 12.98 3.03994L3.31 12.7099C3.11 12.8999 3 13.1499 3 13.4099V16.9999C3 17.5499 3.45 17.9999 4 17.9999ZM5 13.8299L14.38 4.44994C14.66 4.16994 15.04 3.99994 15.46 3.99994C16.31 3.99994 17 4.68994 17 5.53994C17 5.95994 16.83 6.34994 16.55 6.62994L7.17 15.9999H5V13.8299Z"
    />
    <path
      className="g-annotation-icon"
      d="M20 20H4C3.45 20 3 20.45 3 21C3 21.55 3.45 22 4 22H20C20.55 22 21 21.55 21 21C21 20.45 20.55 20 20 20Z"
    />
  </svg>
);

export const NERIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      className="g-annotation-icon"
      d="M3 8V4C3 3.45 3.45 3 4 3H8C8.55 3 9 3.45 9 4C9 4.55 8.55 5 8 5H5V8C5 8.55 4.55 9 4 9C3.45 9 3 8.55 3 8ZM8 19H5V16C5 15.45 4.55 15 4 15C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21H8C8.55 21 9 20.55 9 20C9 19.45 8.55 19 8 19ZM20 15C19.45 15 19 15.45 19 16V19H16C15.45 19 15 19.45 15 20C15 20.55 15.45 21 16 21H20C20.55 21 21 20.55 21 20V16C21 15.45 20.55 15 20 15ZM20 3H16C15.45 3 15 3.45 15 4C15 4.55 15.45 5 16 5H19V8C19 8.55 19.45 9 20 9C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3ZM16.21 8.79C15.82 8.4 15.19 8.4 14.8 8.79L10.51 13.08L9.22 11.79C8.83 11.4 8.2 11.4 7.81 11.79C7.42 12.18 7.42 12.81 7.81 13.2L9.81 15.2C10.01 15.4 10.26 15.49 10.52 15.49C10.78 15.49 11.03 15.39 11.23 15.2L16.23 10.2C16.6 9.82 16.6 9.18 16.21 8.79Z"
    />
  </svg>
);

export const CollectionIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      d="M11 4V10C11 10.55 10.55 11 10 11H4C3.45 11 3 10.55 3 10C3 9.45 3.45 9 4 9H7.59L3.29 4.71C3.11 4.53 3 4.28 3 4C3 3.45 3.45 3 4 3C4.28 3 4.53 3.11 4.71 3.29L9 7.59V4C9 3.45 9.45 3 10 3C10.55 3 11 3.45 11 4ZM20 9H16.41L20.7 4.71C20.89 4.53 21 4.28 21 4C21 3.45 20.55 3 20 3C19.72 3 19.47 3.11 19.29 3.29L15 7.59V4C15 3.45 14.55 3 14 3C13.45 3 13 3.45 13 4V10C13 10.55 13.45 11 14 11H20C20.55 11 21 10.55 21 10C21 9.45 20.55 9 20 9ZM21 14C21 13.45 20.55 13 20 13H14C13.45 13 13 13.45 13 14V20C13 20.55 13.45 21 14 21C14.55 21 15 20.55 15 20V16.41L19.29 20.7C19.47 20.89 19.72 21 20 21C20.55 21 21 20.55 21 20C21 19.72 20.89 19.47 20.71 19.29L16.41 15H20C20.55 15 21 14.55 21 14ZM10 13H4C3.45 13 3 13.45 3 14C3 14.55 3.45 15 4 15H7.59L3.3 19.29C3.11 19.47 3 19.72 3 20C3 20.55 3.45 21 4 21C4.28 21 4.53 20.89 4.71 20.71L9 16.41V20C9 20.55 9.45 21 10 21C10.55 21 11 20.55 11 20V14C11 13.45 10.55 13 10 13Z"
      className="g-annotation-icon"
    />
  </svg>
);

export const DataExtractionIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      d="M11 4C11 4.55 10.55 5 10 5H5V10C5 10.55 4.55 11 4 11C3.45 11 3 10.55 3 10V4C3 3.45 3.45 3 4 3H10C10.55 3 11 3.45 11 4ZM20 13C19.45 13 19 13.45 19 14V19H14C13.45 19 13 19.45 13 20C13 20.55 13.45 21 14 21H20C20.55 21 21 20.55 21 20V14C21 13.45 20.55 13 20 13ZM20 3H14C13.45 3 13 3.45 13 4C13 4.55 13.45 5 14 5H17.59L13.3 9.29C13.11 9.47 13 9.72 13 10C13 10.55 13.45 11 14 11C14.28 11 14.53 10.89 14.71 10.71L19 6.41V10C19 10.55 19.45 11 20 11C20.55 11 21 10.55 21 10V4C21 3.45 20.55 3 20 3ZM11 14C11 13.45 10.55 13 10 13C9.72 13 9.47 13.11 9.29 13.29L5 17.59V14C5 13.45 4.55 13 4 13C3.45 13 3 13.45 3 14V20C3 20.55 3.45 21 4 21H10C10.55 21 11 20.55 11 20C11 19.45 10.55 19 10 19H6.41L10.7 14.71C10.89 14.53 11 14.28 11 14Z"
      className="g-annotation-icon"
    />
  </svg>
);

// Old Annotation icons to be updated

export const AudioSpeachIcon = () => (
  <svg viewBox="0 0 24 24">
    <path
      d="M11.66 2L3 7V17L11.66 22L20.32 17V7L11.66 2ZM15.99 14.5L11.66 17L9.494 18.25V15.75L7.33 14.5V9.5L11.66 7L15.99 9.5V14.5V14.5Z"
      fill="#6A11EA"
    />
    <path
      d="M15.99 4.5L11.66 7L15.99 9.5V14.5L11.66 17L9.496 18.25V15.75L7.33 14.5V9.5L3 12V17L11.66 22L20.32 17V7L15.99 4.5Z"
      fill="#943CFF"
    />
    <path
      d="M15.99 9.5V14.5L11.66 17L9.496 18.25V15.75L7.33 14.5L3 17L11.66 22L20.32 17V7L15.99 9.5Z"
      fill="#DD45D3"
    />
    <path d="M7.33 19.5L11.66 22L20.32 17V12L7.33 19.5Z" fill="#FD9D52" />
  </svg>
);

export const LogisticsIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path className="g-annotation-icon" d="M22.1992 13.1994H19.1992V16.7994L17.9992 16.0007L16.7992 16.7994V13.1994H13.7992C13.4692 13.1994 13.1992 13.4694 13.1992 13.7994V20.9994C13.1992 21.3294 13.4692 21.5994 13.7992 21.5994H22.1992C22.5292 21.5994 22.7992 21.3294 22.7992 20.9994V13.7994C22.7992 13.4694 22.5292 13.1994 22.1992 13.1994ZM7.79922 10.7994H16.1992C16.5292 10.7994 16.7992 10.5294 16.7992 10.1994V2.99941C16.7992 2.66941 16.5292 2.39941 16.1992 2.39941H13.1992V5.99941L11.9992 5.20066L10.7992 5.99941V2.39941H7.79922C7.46922 2.39941 7.19922 2.66941 7.19922 2.99941V10.1994C7.19922 10.5294 7.46922 10.7994 7.79922 10.7994ZM10.1992 13.1994H7.19922V16.7994L5.99922 16.0007L4.79922 16.7994V13.1994H1.79922C1.46922 13.1994 1.19922 13.4694 1.19922 13.7994V20.9994C1.19922 21.3294 1.46922 21.5994 1.79922 21.5994H10.1992C10.5292 21.5994 10.7992 21.3294 10.7992 20.9994V13.7994C10.7992 13.4694 10.5292 13.1994 10.1992 13.1994Z" />
  </svg>
);

export const FinancialServicesIcon = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#clip0)">
    <path className="g-annotation-icon" d="M23.2935 4.44284C21.8389 3.83271 20.3831 3.60059 18.9281 3.60059C14.3092 3.60021 9.69075 5.93834 5.07187 5.93834C3.9135 5.93834 2.75587 5.79134 1.5975 5.42384C1.46737 5.38259 1.33687 5.36309 1.20937 5.36309C0.564 5.36309 0 5.86259 0 6.55596V18.4532C0 18.9268 0.271125 19.3757 0.7065 19.558C2.16112 20.1685 3.61687 20.4006 5.07187 20.4006C9.69075 20.4006 14.3096 18.0625 18.9285 18.0625C20.0869 18.0625 21.2445 18.2095 22.4029 18.577C22.533 18.6182 22.6635 18.6377 22.791 18.6377C23.4364 18.6377 24.0004 18.1382 24.0004 17.4448V5.54796C24 5.07396 23.7289 4.62546 23.2935 4.44284ZM1.8 7.35884C2.5545 7.54784 3.342 7.64271 4.152 7.69371C3.9315 8.79584 2.9625 9.62646 1.8 9.62646V7.35884ZM1.8 18.0463V16.2546C3.08887 16.2546 4.13175 17.2772 4.18912 18.5571C3.34425 18.4892 2.5545 18.3205 1.8 18.0463ZM12 15.6006C10.3429 15.6006 9 13.9885 9 12.0006C9 10.0123 10.3432 8.40059 12 8.40059C13.6567 8.40059 15 10.0123 15 12.0006C15 13.9892 13.6564 15.6006 12 15.6006ZM22.2 16.6423C21.543 16.4777 20.8609 16.3855 20.163 16.3258C20.3831 15.3478 21.1942 14.6053 22.2 14.4778V16.6423ZM22.2 7.78821C21.0416 7.64159 20.1427 6.67446 20.1071 5.48009C20.8399 5.56146 21.5355 5.71371 22.2 5.95484V7.78821Z" />
    </g>
    <defs>
    <clipPath id="clip0">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
  </svg>
);

export const Healthcare = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path className="g-annotation-icon" d="M14.4065 11.543L12.5427 15.2705C12.3177 15.7243 11.6652 15.7093 11.459 15.248L9.32524 10.5118L8.20024 13.2005H4.67149L11.5152 20.1943C11.7815 20.468 12.2127 20.468 12.479 20.1943L19.3265 13.2005H15.2352L14.4065 11.543ZM20.1627 5.17176L20.0727 5.07801C18.1415 3.10551 14.9802 3.10551 13.0452 5.07801L11.999 6.15051L10.9527 5.08176C9.0215 3.10551 5.85649 3.10551 3.92524 5.08176L3.83524 5.17176C2.00899 7.03926 1.93024 10.013 3.56149 12.0005H7.40149L8.74775 8.76801C8.95025 8.28426 9.63274 8.27301 9.85024 8.75301L12.0327 13.6018L13.8702 9.93051C14.0915 9.48801 14.7215 9.48801 14.9427 9.93051L15.9777 12.0005H20.4365C22.0677 10.013 21.989 7.03926 20.1627 5.17176Z" />
  </svg>
);

export const annotationIconsList = {
  cuboid: CuboidIcon,
  segmentation: SegmentationIcon,
  boundingBox: BoundingBoxIcon,
  classification: ClassificationIcon,
  polygon: PolygonIcon,
  point: PointIcon,
  linesSplines: LinesSplinesIcon,
  transcription: TranscriptionIcon,
  ner: NERIcon,
  collection: CollectionIcon,
  dataExtraction: DataExtractionIcon,
  audioSpeech: AudioSpeachIcon,
  logistics: LogisticsIcon,
  financialServices: FinancialServicesIcon,
  healthcare: Healthcare
};

export const annotationContentList = {
  threeD: {
    cuboid: '3-dimensional cuboids to describe the width, height and depth of targeted objects.',
    segmentation: 'Full semantic, instance or panoptic segmentation of point clouds.'
  },
  image: {
    boundingBox: 'Annotation to describe the width, height and location of target objects.',
    classification:
      ' Classification, or categorization of entire images into pre-defined categories.',
    cuboid: '3-dimensional cuboids to describe the width, height and depth of target objects.',
    linesSplines: 'Annotation of straight or curved lines, polylines and splines.',
    point: ' Annotation of landmarks on objects of interest.',
    polygon: ' Annotation of the exact edges of target objects for more precise definition.',
    segmentation: ' Full semantic, instance, or panoptic segmentation of images.',
    transcription:
      'identify and extract structured text from images optionally adding bounding boxes.'
  },
  video: {
    boundingBox: 'Annotation to describe the width, height and location of target objects.',
    classification: 'Classification of entire videos into pre-defined categories.',
    cuboid: '3-dimensional cuboids to describe the width, height, and depth of target objects.',
    polygon: 'Annotation of the exact edges of target objects for more precise definition.'
  },
  text: {
    ner:
      'Structure text by identifying, classifying, and linking text into pre-defined categories.',
    classification:
      'Classification, or categorization of entire texts into pre-defined categories.',
    mlTranscription:
      'Identify and extract structured text from documents, images, and other unstructured data.',
    mlDataCollection: 'Collection of free-form text data from a diverse workforce.'
  },
  document: {
    classification: 'Classification of documents into pre-defined categories.',
    mlTranscription: 'Transcription of text in documents.',
    dataExtraction:
      'Identify and extract structured text from documents with the option to add bounding boxes.'
  },
  mapping: {
    vectorMaps: '',
    semanticMaps: '',
    semanticLinking: ''
  }
};

export default CuboidIcon;
